export const JOB_YEAR_OF_PASSING_OPTIONS: number[] = [
    2020,
    2021,
    2022,
    2023,
    2024,
    2025,
    2026,
    2027
];